import React from 'react';
import { SEOHead } from '../components/common/SEOHead';
import { Breadcrumbs } from '../components/common/Breadcrumbs';

export default function TermsPage() {
  return (
    <>
      <SEOHead
        title="Terms & Conditions"
        description="Terms and Conditions for Passion of Aroma. Read our terms of service for wholesale fragrance distribution."
        canonical="https://passionofaroma.com/terms"
      />

      <section className="pt-32 pb-8 bg-[#0B1F3B]">
        <div className="container-custom">
          <Breadcrumbs items={[{ label: 'Terms & Conditions' }]} />
          <h1 className="heading-xl text-white mt-6">Terms & Conditions</h1>
        </div>
      </section>

      <section className="py-16 bg-white" data-testid="terms-content">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto prose prose-lg">
            <p className="text-gray-500 mb-8">Last updated: January 2024</p>

            <h2 className="heading-md mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-600 mb-6">
              By accessing and using the Passion of Aroma website and services, you agree 
              to be bound by these Terms and Conditions. If you do not agree to these terms, 
              please do not use our services.
            </p>

            <h2 className="heading-md mb-4">2. Business Transactions</h2>
            <p className="text-gray-600 mb-6">
              Our services are intended for business-to-business (B2B) transactions. By 
              placing an order, you represent that you are a registered business entity 
              authorized to conduct wholesale purchases.
            </p>

            <h2 className="heading-md mb-4">3. Product Authenticity</h2>
            <p className="text-gray-600 mb-6">
              All products sold by Passion of Aroma are 100% authentic and sourced from 
              authorized channels. We guarantee the authenticity of every product we sell.
            </p>

            <h2 className="heading-md mb-4">4. Pricing and Payment</h2>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>All prices are quoted in INR unless otherwise specified</li>
              <li>Prices are subject to change without prior notice</li>
              <li>Payment terms are agreed upon during order confirmation</li>
              <li>Orders are confirmed only after payment verification</li>
            </ul>

            <h2 className="heading-md mb-4">5. Minimum Order Quantity</h2>
            <p className="text-gray-600 mb-6">
              Minimum order quantities (MOQ) vary by product and brand. Specific MOQ 
              requirements will be communicated during the quotation process.
            </p>

            <h2 className="heading-md mb-4">6. Shipping and Delivery</h2>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Delivery times are estimates and not guaranteed</li>
              <li>Shipping costs are calculated based on destination and order size</li>
              <li>Risk of loss transfers upon delivery to the carrier</li>
            </ul>

            <h2 className="heading-md mb-4">7. Returns and Refunds</h2>
            <p className="text-gray-600 mb-6">
              Returns are accepted only for damaged or incorrect products. Claims must be 
              made within 48 hours of delivery with photographic evidence. Refunds or 
              replacements will be processed after verification.
            </p>

            <h2 className="heading-md mb-4">8. Intellectual Property</h2>
            <p className="text-gray-600 mb-6">
              All content on this website, including logos, images, and text, is the 
              property of Passion of Aroma or its licensors. Unauthorized use is prohibited.
            </p>

            <h2 className="heading-md mb-4">9. Limitation of Liability</h2>
            <p className="text-gray-600 mb-6">
              Passion of Aroma shall not be liable for any indirect, incidental, or 
              consequential damages arising from the use of our products or services.
            </p>

            <h2 className="heading-md mb-4">10. Governing Law</h2>
            <p className="text-gray-600 mb-6">
              These terms shall be governed by and construed in accordance with the laws 
              of India. Any disputes shall be subject to the exclusive jurisdiction of 
              the courts in Ahmedabad, Gujarat.
            </p>

            <h2 className="heading-md mb-4">11. Contact</h2>
            <p className="text-gray-600 mb-6">
              For questions about these terms, contact us at:<br />
              Email: info@passionofaroma.com<br />
              Phone: +91 98765 43210
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
